import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { useShortFromPropsOrParams } from '../shortContentHooks';
import { ExternalLearningContentBanner } from '../../learningContent';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ShortContentDetails = props => {
  const {
    short
  } = useShortFromPropsOrParams(props);
  if (!short) {
    return null;
  }
  const {
    description,
    subCategories,
    hubId
  } = short;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(View, {
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(ExternalLearningContentBanner, {
        hubId: hubId
      })
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.shortContent.descriptionHeader"
      })
    }), /*#__PURE__*/_jsx("p", {
      children: description
    }), /*#__PURE__*/_jsx(Flex, {
      columnGap: "400",
      flexWrap: "wrap",
      rowGap: "200",
      children: subCategories.map(subCategory => /*#__PURE__*/_jsx(Tag, {
        inline: true,
        margin: "0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyCategories.${subCategory}`
        })
      }, subCategory))
    })]
  });
};
export default ShortContentDetails;